module.exports = __webpack_public_path__ + "img/wb_bg_invest.284fc5cd.jpg";